export default __webpack_public_path__ + "static/12-58519ced83efbec41f5b21bcd3879cac.jpg";